import script from "./StickersUpsell.vue?vue&type=script&setup=true&lang=js"
export * from "./StickersUpsell.vue?vue&type=script&setup=true&lang=js"

import "./StickersUpsell.vue?vue&type=style&index=0&id=a19e1172&lang=scss"

const __exports__ = script;

export default __exports__